import React, { useState, useEffect } from 'react'
import { Option, Select } from '../style'
import ApiService from '../../../services/ApiService'
import { companyComponentsProps, typesInterface } from '../types'

const SelectTypeComponent:React.FC<companyComponentsProps> = (props) => {
  const { company, setCompany } = props
  const [ types, setTypes ] = useState<typesInterface[]>([])

  const handleSeachTypes = () => {
    ApiService.companies.getTypes()
    .then((response: any) => {
      if(response.data) setTypes(response.data)
    })
    .catch((error: any) => {
      console.log(error)
    })

  }

  const handleSetTypes = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (setCompany) {
      setCompany((prev:any) => {
        const typeObject = types.filter(obj => obj.typeName === e.target.value)
        return {
          ...prev,
          companyTypes:typeObject[0] || {typeName:''}
        }
      })
    }
  }
  
  return(
    <Select onFocus={handleSeachTypes} value={company?.companyTypes?.typeName || ''} onChange={(e) => handleSetTypes(e)}>
     
      <Option value={''}>{company?.companyTypes?.typeName || 'Selecione'}</Option>
      {types.map((item, index) => 
      
        <Option key={index} value={item.typeName}>{item.typeName}</Option>
      )}
    </Select>
  )
}

export default SelectTypeComponent